var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10668_3211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75C5.2725 0.75 2.25 3.7725 2.25 7.5V12.75C2.25 13.995 3.255 15 4.5 15H6.75V9H3.75V7.5C3.75 4.5975 6.0975 2.25 9 2.25C11.9025 2.25 14.25 4.5975 14.25 7.5V9H11.25V15H14.25V15.75H9V17.25H13.5C14.745 17.25 15.75 16.245 15.75 15V7.5C15.75 3.7725 12.7275 0.75 9 0.75Z",
    fill: "#FDFDFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10668_3211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTickets);
export default __webpack_public_path__ + "static/media/support-tickets.cb55f24ce7cfef2d574a1384d6eadd96.svg";
export { ForwardRef as ReactComponent };